import toDate from '../to-date';

export const isBeforeDate = (firstDate: Date | number, secondDate: Date | number): boolean => {
  return toDate(firstDate).getTime() < toDate(secondDate).getTime();
};

export default isBeforeDate;
